module.exports = __webpack_public_path__ + "static/IncreaseTime-0e2877d8014b41cc2138752e98546908.png";